'use client';

import BackgroundImage from '@components/background-image/BackgroundImage';
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import Big from '@images/renders/infrastructure_images/Infra_Desktop_Webp/14.webp';
import Medium from '@images/renders/infrastructure_images/Infra_Desktop_Webp/15.webp';
import Small from '@images/renders/infrastructure_images/Infra_Desktop_Webp/16.webp';
import { handleStartPanoramaPreload } from '@lib/store/slices/ComponentsSlice';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { showAnimate } from '@lib/tools/utils';
import { useLayoutEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import style from './SeventhScreenInfra.module.scss';

function SeventhScreenInfra({ isMobile }) {
  const dispatch = useDispatch();

  const [toggle, setToggle] = useState(false);

  const svgRef = useRef(null);
  const titleRef = useRef(null);
  const boxRef = useRef(null);

  useLayoutEffect(() => {
    if (svgRef && !toggle) {
      let st5 = null;
      const element = svgRef.current;

      setTimeout(() => {
        st5 = ScrollTrigger.create({
          trigger: element,
          start: 'top center', // end: "bottom bottom",
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle(() => true);
              dispatch(handleStartPanoramaPreload(true));
            }, 500);
          },
        });

        showAnimate(titleRef, titleRef.current);
        showAnimate(boxRef, boxRef.current);

        return () => {
          st5.kill();
        };
      }, 1000);
    }
  }, [svgRef, isMobile]);

  return (
    <div data-scroll className={style.thirdScreenContainer} ref={svgRef} id='seven'>
      <BackgroundImage className={style.thirdScreenImg} src={Big} name='bgr_3' imagePlug={Big} />

      <div ref={titleRef} className={style.thirdScreenTitle}>
        <p className='will-show'>Инфраструктура</p>
        <p className='will-show'>считанных шагов</p>
      </div>

      <div ref={boxRef} className={style.thirdScreenDescription}>
        <p className='will-show'>
          Побаловать внутреннего кофемана во&nbsp;время прогулки, вкусно перекусить или поужинать всей семьёй вне дома
          можно не&nbsp;покидая Моментс.
        </p>
      </div>
      <div className={style.thirdScreenLowContainer}>
        <div>
          <div className={style.thirdScreenLowContainerTextWrapper}>
            <p>
              Кофейни, пекарни, рестораны и&nbsp;семейные кафе расположены вдоль прогулочных зон. Решение насущных
              вопросов&nbsp;тоже&nbsp;не будет&nbsp;отнимать много времени.
            </p>
            <p>
              Супермаркет, гастрономические лавки, винотека, салоны красоты, ателье, химчистка, аптека и&nbsp;прочие
              полезные сервисы расположены на&nbsp;первых этажах.
            </p>
            <div>
              {!isMobile && (
                <ParallaxMedia
                  dataScroll={true}
                  dataScrollSpeed='-0.5'
                  dataScrollTarget='#seven'
                  src={Medium}
                  className={style.thirdScreenLowContainerMediumImg}
                  imagePlug={Medium}
                />
              )}
            </div>
          </div>
          <div>
            {!isMobile && (
              <ParallaxMedia
                dataScroll={true}
                dataScrollSpeed='-0.5'
                dataScrollTarget='#seven'
                src={Small}
                className={style.thirdScreenLowContainerSmallImg}
                imagePlug={Small}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SeventhScreenInfra;
